import { render, staticRenderFns } from "./addSubCategory.vue?vue&type=template&id=37bb16e4&"
import script from "./addSubCategory.vue?vue&type=script&lang=js&"
export * from "./addSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports